<template>
  <div>
    <div class="font-weight-prop col-xs-12 p-0">
      <div class="sub-approval">Date Range</div>
    </div>
    <div class="alert-menu col-xs-12 p-0 m-0">
      <date-picker
        v-model="start_approval_date"
        :default-value="start_approval_date ? start_approval_date : new Date()"
        :disabled-date="notBeforeApprovalEndDate"
        :editable="false"
        type="date"
        placeholder="DD-MM-YYYY"
        format="DD-MM-YYYY"
        :valueType="dateFormat"
        @change="onDateRangeSelection()"
      ></date-picker>
      <div class="start-to-end">to</div>
      <date-picker
        v-model="end_approval_date"
        :disabled-date="notBeforeApprovalStartDate"
        :default-value="end_approval_date ? end_approval_date : new Date()"
        :editable="false"
        type="date"
        placeholder="DD-MM-YYYY"
        format="DD-MM-YYYY"
        :valueType="dateFormat"
        @change="onDateRangeSelection()"
      ></date-picker>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import EventBus from '../../utils/event-bus';

export default {
  // props: ['dateFormat', 'eventType', 'label'],
  props: {
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    eventType: {
      type: String
    },
    label: {
      type: String
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      start_approval_date: '',
      end_approval_date: '',
      isDateRangeSelected: false
    };
  },

  mounted() {
    EventBus.$on(`setCustomDatesFor${this.eventType}`, (dateRange) => {
      this.start_approval_date = moment(dateRange.startDate).format(this.dateFormat);
      this.end_approval_date = moment(dateRange.endDate).format(this.dateFormat);
      this.isDateRangeSelected = true;
    });
    EventBus.$on(`normalDatesSelected${this.eventType}`, () => {
      this.setDefaultDateValues();
    });
    EventBus.$on('clearAllCustomDates', () => {
      this.setDefaultDateValues();
    });
  },

  beforeDestroy() {
    EventBus.$off(`normalDatesSelected${this.eventType}`);
    EventBus.$off(`setCustomDatesFor${this.eventType}`);
    EventBus.$off('clearAllCustomDates');
  },

  methods: {
    notBeforeApprovalEndDate(date) {
      if (this.end_approval_date) {
        return date > new Date(this.end_approval_date).setHours(0, 0, 0, 0);
      }
      return '';
    },

    notBeforeApprovalStartDate(date) {
      return date < new Date(this.start_approval_date).setHours(0, 0, 0, 0);
    },

    onDateRangeSelection() {
      if (this.start_approval_date && this.end_approval_date) {
        let dateRange;
        if (this.label === 'records') {
          dateRange = {
            from: new Date(moment(this.start_approval_date).format(this.dateFormat)).toISOString(),
            to: new Date(moment(this.end_approval_date).format(this.dateFormat)).toISOString()
          };
        } else {
          dateRange = {
            from: moment(this.start_approval_date).format(this.dateFormat),
            to: moment(this.end_approval_date).format(this.dateFormat)
          };
        }
        this.isDateRangeSelected = true;
        this.$emit('dateRange', dateRange);
      } else if (this.isDateRangeSelected) {
        if (!this.start_approval_date || !this.end_approval_date) {
          this.isDateRangeSelected = false;
          this.clearDateRangeInFilter();
        }
      }
    },

    clearDateRangeInFilter() {
      const dateRange = {};
      this.$emit('dateRange', dateRange);
    },

    setDefaultDateValues() {
      if (this.start_approval_date || this.end_approval_date) {
        this.isDateRangeSelected = false;
        this.start_approval_date = '';
        this.end_approval_date = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .alert-menu {
  margin-bottom: 5px;
  .mx-datepicker {
    width: 124px;
    .mx-input {
      padding: 4px 6px 4px 32px;
      font-size: 13px;
      color: $black;
      border: 0.5px solid $black;
      border-radius: 3px;
      font-weight: $font-weight-small;
    }
    .mx-input-wrapper {
      .mx-icon-calendar {
        left: 8px;
      }
      .mx-icon-clear {
        right: 98px;
      }
    }
  }
  .el-input--suffix {
    .el-input__inner {
      padding-right: 0px;
    }
  }
}
.start-to-end {
  font-size: $font-14;
  line-height: 14px;
  color: $dark-black-alpha;
  padding: 10px 8px;
  display: inline;
}
.sub-approval {
  color: $primary;
  font-size: $font-16;
  line-height: 19px;
  margin-bottom: 13px;
}
</style>
